import React, { useState } from 'react';
import './css/CorporateResponsibility.css';

import pictureTwo from './assets/picTwo.jpg';
import pictureThree from './assets/picThree.jpg';
import pictureFour from './assets/picFour.jpg';
import pictureFive from './assets/picFive.jpg';

const Responsibility = () => {
  const stories = [
    {
      img: pictureTwo,
      title: "MBS Pumps In K10 Million In The MBC's Top Of Class Programme",
      text: "Malawi Broadcasting Corporation (MBC) has partnered Malawi Bureau of Standards, which will see the latter sponsoring one of MBC's flagship programmes, Top of the Class.",
      fullText: "Full Story: The MBS commitment of K10 Million to the MBC Top of Class Programme supports educational excellence across Malawi. This funding will allow for additional learning resources, mentorship programs, and nationwide participation. Students from all regions will benefit from improved educational tools, competitions, and opportunities to excel in their studies."
    },
    {
      img: pictureThree,
      title: 'MBS collaborates with ARSO to conduct the "11th ARSO Continental Essay competition"',
      text: 'Malawi Bureau of Standards (MBS) in collaboration with ARSO conducted the 11th Continental Essay competition...',
      fullText: "Full Story: The essay competition aimed to inspire students across Africa to explore standards and quality issues in their communities. Winners received recognition at a continental ceremony, scholarships, and mentorship opportunities, fostering leadership and awareness in standards application."
    },
    {
      img: pictureFour,
      title: 'MBS Participates In 2024 Mining Investment Forum',
      text: 'The Malawi Bureau of Standards (MBS) participated in the two-day Malawi Mining Investment Forum (MMIF)...',
      fullText: "Full Story: MBS showcased its technical capabilities in testing, inspection, and standards enforcement to attract investors. The forum provided an avenue for dialogue between industry leaders and MBS, enhancing trust in compliance and quality assurance across the mining sector."
    },
    {
      img: pictureFive,
      title: "MBS Supports National Schools' Science Fair With K2m",
      text: 'Malawi Bureau of Standards (MBS) supported the National Schools Science Fair...',
      fullText: "Full Story: MBS allocated K2 million to enhance the Science Fair, providing prizes, lab equipment, and guidance for participants. The initiative encouraged practical learning, innovation, and STEM development in Malawi’s youth."
    },
  ];

  const [startIndex, setStartIndex] = useState(0);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const prevSlide = () => {
    setStartIndex(prev => (prev - 2 >= 0 ? prev - 2 : 0));
  };

  const nextSlide = () => {
    setStartIndex(prev => (prev + 2 < stories.length ? prev + 2 : prev));
  };

  const toggleReadMore = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="header-responsibility">
      {/* Overlay Header */}
      <section
        className="responsibility-header"
        style={{
          backgroundImage: `url(${pictureTwo})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '45vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div className="overlay">
          <h1 className="page-title">Corporate Social Responsibility</h1>
          <p className="subtitle">
            Malawi Bureau of Standards (MBS) supports initiatives in health, education, community development, the environment, the arts, and sports development.
          </p>
        </div>
      </section>

      {/* Featured Stories */}
      <section className="featured-stories" style={{ maxWidth: '1200px', margin: '50px auto', position: 'relative' }}>
        <h2 className="section-title">
          <span className="line"></span> Featured CSR <span className="line"></span>
        </h2>

        {/* Arrows */}
        <button className="arrow left-arrow" onClick={prevSlide}>&lt;</button>
        <button className="arrow right-arrow" onClick={nextSlide}>&gt;</button>

        {/* Story Grid */}
        <div className="stories-grid">
          {stories.slice(startIndex, startIndex + 2).map((story, index) => (
            <div key={startIndex + index} className="story-card">
              <div className="story-image-wrapper">
                <img src={story.img} alt={story.title} className="story-image" />
              </div>
              <div className="story-content">
                <h3 className="story-title">{story.title}</h3>
                <p className="story-text">
                  {expandedIndex === startIndex + index ? story.fullText : story.text}
                </p>
                <button
                  className="read-more-btn"
                  onClick={() => toggleReadMore(startIndex + index)}
                >
                  {expandedIndex === startIndex + index ? 'Show Less' : 'Read More'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <style>{`

      .responsibility-header .overlay {
    background: rgba(0, 0, 0, 0.5);
    padding: 2rem;
    border-radius: 1rem;
    border-right: 4px solid #ff6600;
    border-left: 4px solid #ff6600;
    width: 90%;
}
          .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 12px;
        }
        .page-title {
          font-size: 3rem;
          font-weight: bold;
          margin-bottom: 15px;
        }
        .subtitle {
          font-size: 1.2rem;
          margin-top: 5px;
          font-weight: 500;
        }
        .section-title {
          text-align: center;
          font-size: 2rem;
          margin-bottom: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;
        }
        .line {
          flex: 1;
          height: 2px;
          background-color: #ccc;
        }
        .stories-grid {
          display: flex;
          gap: 40px;
          justify-content: center;
        }
        .story-card {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
          transition: transform 0.3s, box-shadow 0.3s;
          flex: 1 1 45%;
          display: flex;
          flex-direction: column;
        }
        .story-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 16px 40px rgba(0,0,0,0.2);
        }
        .story-image-wrapper {
          width: 100%;
          max-height: 350px;
          overflow: hidden;
        }
        .story-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s;
        }
        .story-card:hover .story-image {
          transform: scale(1.1);
        }
        .story-content {
          padding: 25px 20px;
        }
        .story-title {
          font-size: 1.3rem;
          font-weight: bold;
          margin-bottom: 12px;
        }
        .story-text {
          font-size: 1rem;
          line-height: 1.7;
          color: rgba(0,0,0,0.85);
          margin-bottom: 15px;
        }
        .read-more-btn {
          padding: 8px 15px;
          background: #ff6c2f;
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-weight: bold;
          transition: background 0.3s;
        }
        .read-more-btn:hover {
          background: #ff6c2f;
        }
        .arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(0,0,0,0.6);
          color: white;
          border: none;
          font-size: 2rem;
          padding: 10px 15px;
          cursor: pointer;
          border-radius: 8px;
          z-index: 10;
        }
        .left-arrow { left: -30px; }
        .right-arrow { right: -30px; }

        @media (max-width: 1024px) {
          .stories-grid {
            flex-direction: column;
            gap: 40px;
          }
          .arrow {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default Responsibility;
